import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { CalendarModule } from 'primeng/calendar';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';
import * as dayjs from 'dayjs';
import 'dayjs/plugin/utc';
import 'dayjs/plugin/timezone';

@Component({
  selector: 'app-date-year',
  templateUrl: './date-year.component.html',
  styleUrls: ['./date-year.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CalendarModule]
})
export class DateYearComponent implements OnInit {
  @Input() field: any;
  formName: FormGroup;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  placeholder: any;
  minDate: Date;
  maxDate: Date;

  constructor(private formGroupDirective: FormGroupDirective,
    private metaDataService: MetaDataService,
    public cs: CommonBindingDataService) {
    this.formName = this.formGroupDirective.control;
  }

  ngOnInit(): void {
    const selectedTimezone = this.metaDataService.getSelectedTimezone();
    const currentTimeInUTC = dayjs().utc();
    const userTime = currentTimeInUTC.tz(selectedTimezone, true);
    this.setFormControlValue(userTime);
    this.placeholder = this.cs.getLabelValue(`${this.moduleName  }.fields.${  this.field.attributeCode  }.placeholder`, this.attributeLabels, null);
    const currentDate = new Date();
    this.maxDate = new Date(currentDate.getFullYear(), 11, 31);
    const minYear = currentDate.getFullYear() - 24;
    this.minDate = new Date(minYear, 0, 1);
  }

  setFormControlValue(userTime: dayjs.Dayjs) {
    const controlName = this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field?.attributeCode;
    const editValue = this.formName.controls[controlName].value;
    if (editValue) {
      this.formName.controls[controlName].setValue(editValue.toDate());
    } else {
      this.formName.controls[controlName].setValue(userTime.toDate());
    }
  }
}
